import { BottomSheet } from "react-spring-bottom-sheet";

import HFlex from "../layouts/HFlex";
import VFlex from "../layouts/VFlex";
import Text from "../layouts/Text";

import "react-spring-bottom-sheet/dist/style.css";

import SvgIcon, { SvgIconType } from "../svg";

function ServiceNotePostBottomSheet({
  open,
  onDismiss,
  onComplete,
}: {
  open: boolean;
  onDismiss: () => void;
  onComplete: () => void;
}) {
  return (
    <BottomSheet
      className="bottomsheet"
      open={open}
      initialFocusRef={false}
      expandOnContentDrag={true}
      onDismiss={onDismiss}
    >
      <HFlex a-c p-24-rl height={44}>
        <Text f-1 t-22-600>
          감사 인사말을 보낼까요?
        </Text>
        <SvgIcon
          size={24}
          icon={SvgIconType.Close}
          onClick={() => onDismiss()}
        />
      </HFlex>
      <VFlex p-24-rl g-16>
        <Text f-1 t-16-gd>
          작성한 메시지는 파트너에게 전달됩니다.
        </Text>
        <VFlex a-st p-24-tb height={112}>
          <VFlex
            f-1
            c-c
            bdr-16
            t-18-ww
            bc-pt
            onClick={(e) => {
              e.preventDefault();
              onComplete();
            }}
          >
            보내기
          </VFlex>
        </VFlex>
      </VFlex>
    </BottomSheet>
  );
}

export default ServiceNotePostBottomSheet;
